import { setCookie } from '@atlassian/browser-storage-controls';
const LAST_VIEWED_FORM_COOKIE_NAME_PREFIX = 'lastViewedForm-';
export const setLastViewedForm = async (projectId, lastViewedFormCookie) => {
  const updatedLastViewedFormCookie = lastViewedFormCookie !== null && lastViewedFormCookie !== void 0 && lastViewedFormCookie.templateFormId ? lastViewedFormCookie : {};
  await setCookie(`${LAST_VIEWED_FORM_COOKIE_NAME_PREFIX}${projectId}`, JSON.stringify(updatedLastViewedFormCookie), {
    sameSite: 'None',
    secure: true
  });
};